import TypographyProps from './TypographyProps';

const typography: TypographyProps = {
  fontFamily: {
    primary: {
      get main() {
        return `"HelveticaNeue", Helvetica, Arial, sans-serif`;
      },
    },
  },
  fontSize: {
    xxxl: {
      value: 3.125,
      get rem() {
        return `${this.value}rem`;
      },
    },
    xxl: {
      value: 2.25,
      get rem() {
        return `${this.value}rem`;
      },
    },
    xl: {
      value: 1.5,
      get rem() {
        return `${this.value}rem`;
      },
    },
    l: {
      value: 1.125,
      get rem() {
        return `${this.value}rem`;
      },
    },
    m: {
      value: 1,
      get rem() {
        return `${this.value}rem`;
      },
    },
    s: {
      value: 0.8125,
      get rem() {
        return `${this.value}rem`;
      },
    },
    xs: {
      value: 0.6875,
      get rem() {
        return `${this.value}rem`;
      },
    },
    xxs: {
      value: 0.5,
      get rem() {
        return `${this.value}rem`;
      },
    },
    xxxs: {
      value: 0.5,
      get rem() {
        return `${this.value}rem`;
      },
    },
  },
  headline: {
    xl: {
      value: 3.125,
      get rem() {
        return `${this.value}rem`;
      },
    },
    l: {
      value: 2.25,
      get rem() {
        return `${this.value}rem`;
      },
    },
    m: {
      value: 1.5,
      get rem() {
        return `${this.value}rem`;
      },
    },
    s: {
      value: 1.25,
      get rem() {
        return `${this.value}rem`;
      },
    },
  },
  lineHeight: {
    xxxl: {
      value: 1,
    },
    xxl: {
      value: 1,
    },
    xl: {
      value: 1.17,
    },
    l: {
      value: 1.44,
    },
    m: {
      value: 1.25,
    },
    s: {
      value: 1.23,
    },
    xs: {
      value: 1.36,
    },
    xxs: {
      value: 1.25,
    },
    xxxs: {
      value: 1.25,
    },
  },
};

export default typography;
